import { Controller } from "stimulus"
import $ from 'jquery'

export default class extends Controller {
  hideRow(event) {
    return $(event.currentTarget).hide(500)
  }
}
